import React from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IconChevronLeft, IconTrendingUp, IconAlertCircle } from '@tabler/icons-react';
import { colors, fonts } from '../../ColorFont/color';

const CarbonCreditsSellCredit = ({ onBack }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleBack = () => {
        if (onBack) onBack();
        else navigate('/carbon-credits');
    };

    return (
        <Box sx={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: '#FAFAFA',
            pb: 10
        }}>
            <Box sx={{
                maxWidth: '720px',
                mx: 'auto',
                px: { xs: '16px', md: 0 },
                pt: { xs: 2, md: 4 }
            }}>
                {/* Back button */}
                <Button
                    onClick={handleBack}
                    variant="outlined"
                    startIcon={<IconChevronLeft size={18} stroke={2.5} />}
                    sx={{
                        borderRadius: '50px',
                        px: 3,
                        height: '48px',
                        fontFamily: fonts.publicSans || fonts.poppins,
                        fontWeight: 700,
                        fontSize: '14px',
                        textTransform: 'none',
                        color: colors.carbon_text_main || '#1C252E',
                        borderColor: '#E0E5EB',
                        mb: '24px',
                        minWidth: '110px',
                        '&:hover': {
                            borderColor: '#919EAB',
                            backgroundColor: '#F4F6F8',
                        },
                    }}
                >
                    Back
                </Button>

                {/* Title */}
                <Box sx={{ mb: '40px' }}>
                    <Typography sx={{
                        fontFamily: fonts.manrope || fonts.poppins,
                        fontWeight: 700,
                        fontSize: '28px',
                        letterSpacing: '-0.6px',
                        color: colors.carbon_text_main || '#0F1729',
                        mb: '8px',
                    }}>
                        Sell Carbon Credits
                    </Typography>
                    <Typography sx={{
                        fontFamily: fonts.publicSans || fonts.poppins,
                        fontSize: '15px',
                        color: '#65758B',
                        lineHeight: 1.6
                    }}>
                        Convert your verified carbon credits into earnings by selling them on the marketplace.
                    </Typography>
                </Box>

                {/* Placeholder Content */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 10,
                    px: 4,
                    gap: '24px',
                    border: `2px dashed ${colors.carbon_border_dashed || '#E2E8F0'}`,
                    borderRadius: '24px',
                    background: 'rgba(255,255,255,0.7)',
                    textAlign: 'center'
                }}>
                    <Box sx={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '20px',
                        background: 'rgba(0,180,216,0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: colors.carbon_bg_main || '#00B4D8',
                    }}>
                        <IconTrendingUp size={40} stroke={1.5} />
                    </Box>
                    
                    <Box>
                        <Typography sx={{
                            fontFamily: fonts.manrope || fonts.poppins,
                            fontWeight: 700,
                            fontSize: '20px',
                            color: colors.carbon_text_main || '#0F1729',
                            mb: '12px',
                        }}>
                            Coming Soon
                        </Typography>
                        <Typography sx={{
                            fontFamily: fonts.publicSans || fonts.poppins,
                            fontSize: '15px',
                            color: '#64748B',
                            maxWidth: '400px',
                            mx: 'auto'
                        }}>
                            We're currently building the carbon credit marketplace. You'll be able to list your verified credits for sale very soon!
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        p: '12px 20px',
                        background: '#FFF4E5',
                        borderRadius: '12px',
                        mt: 2
                    }}>
                        <IconAlertCircle size={20} color="#B76E00" />
                        <Typography sx={{
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#B76E00',
                            fontFamily: fonts.publicSans || fonts.poppins
                        }}>
                            Credits must be verified before they can be sold.
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CarbonCreditsSellCredit;
